
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import "../style/App.css";
import "../style/Home.css";
import "../style/ReactBootstrapOverride.css";

// className="gradient-aboutus"

const AboutUsOurVision = () => {

    return (
        <Container fluid >

            <Row>
                <Col md={{ span: 3, offset: 3 }}>
                    <h1 style={{textAlign: "center"}}>
                        OUR VISION
                    </h1>
                </Col>
            </Row>
            
            <Row className="pl-5 ml-5">
                <Row>
                    <Col  md={{ span: 9, offset: 3 }} style={ 
                                                    { background: "linear-gradient(to top right, #e30a13, #e30a13, #e30a13, #e30a13, #f18286)"  }}>
                    <p className="col-white px-5 mx-5">
                        To bring the benefits of new technology and skills acquisition pedagogy to surgical training to advance the next generation of surgeons and relieve an overburdened health system.
                    </p>
                    </Col>
                </Row>
            </Row>
        </Container>
    );
}

export default AboutUsOurVision;